<template>
    <section id="home-news" class="home-news home-section section-image bg-line-02">
        <!-- <div class="home-news-header">

            <div class="subtitle">
                <span class="material-symbols-outlined">newspaper</span>
                <span>บล็อกของคณะสังคมศาสตร์ มหาวิทยาลัยศรีนครินทรวิโรฒ</span>
            </div>

            <h2 class="title">
                <strong>ข่าวล่าสุด</strong> <span>อัปเดต</span>
            </h2>
        </div> -->

        <div class="home-news-content">
            <div class="home-news-tabs">
                <div class="tabs">
                    <div class="tab-item tab-icon"><span class="material-symbols-outlined">newspaper</span></div>
                    <div class="tab-item" v-for="(item, index) in categories" :key="index">
                        <a :href="item.path" class="tab-link" :class="currentIndex == index && `active`"
                            @click.prevent="currentIndex = index">
                            <span class="tab-text">{{ item.categoryName }}</span>
                        </a>
                    </div>
                </div>
            </div>

            <div class="home-news-post">
                <div class="post-grid">
                    <div class="post-card" v-for="(post, index) in postList" :key="index">
                        <a class="post-item" :href="post.uri">
                            <div class="post-pic">
                                <img v-if="post.imageUrl" :src="post.imageUrl" :alt="post.title" />
                            </div>
                            <div class="post-content">
                                <h3 class="post-title">{{ post.title }}</h3>
                                <div class="post-date">{{ post.date }}</div>
                                <div class="post-synopsis">{{ post.description }}</div>

                                <div class="link-primary">
                                    <span class="link-primary-text">{{ $t('newsMore') }}</span>
                                    <span class="link-primary-icon material-symbols-outlined">east</span>
                                </div>
                            </div>
                        </a>
                    </div>
                </div>

                <div class="home-news-footer" v-if="linkNewsMore">
                    <a :href="linkNewsMore" class="btn btn-primary btn-icon-wrap">
                        <span class="btn-icon material-symbols-outlined">north_east</span>
                        <span class="btn-text">{{ $t('SeeMoreNews') }}</span>
                    </a>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    name: "HomeNews",
    props: ['categories', 'thumbnail'],

    computed: {
        postList() {
            const category = this.categories.find((n, i) => i == this.currentIndex)
            if (!category) return [];

            return category.posts
        },

        linkNewsMore() {
            const category = this.categories.find((n, i) => i == this.currentIndex)
            if (!category) return null;

            return category.path


        }
    },

    data() {
        return {
            currentIndex: 0
        }
    },
}
</script>

<style lang="scss" scoped>
.home-news-header {
    text-align: center;
    margin-top: 30px;
    margin-bottom: 30px;

    .subtitle {
        display: none;
    }

    .title {
        font-size: 32px;
        font-weight: bold;
    }
}

.home-news-tabs {
    margin-top: 15px;
    margin-bottom: 15px;
}

.tabs {
    display: flex;
}

.tab-link {
    display: flex;
    height: 52px;
    padding-left: 24px;
    padding-right: 24px;
    align-items: center;
    background-color: #fff;

    text-decoration: none;
    color: #000;
    
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;

    &:hover {
        cursor: pointer;
        color: var(--primary);
    }

    &.active {
        background-color: var(--primary);
        color: #fff;
    }
}

.post-grid {
    display: flex;
    flex-wrap: wrap;
    margin-right: -15px;
}

.post-card {
    display: block;

    position: relative;
    width: 100%;

    flex: 0 0 50%;
    max-width: 50%;
    padding-right: 15px;
    margin-bottom: 15px;
}

.post-item {
    display: flex;
    flex-direction: column;
    text-decoration: none;
    gap: 8px;
}

.post-pic {
    background-color: #cdbad0;
    // padding-top: 68.25%;
    padding-top: 56.25%;
    display: block;
    overflow: hidden;
    height: 0;
    position: relative;

    img {
        position: absolute;
        inset: 0;

        object-fit: cover;
        width: 100%;
        height: 100%;
    }
}

.post-content {
    display: flex;
    flex-direction: column;
    gap: 3px;
}

.post-title {
    color: #000;
    font-size: var(--card-post-title-size, 18px);
    line-height: var(--card-post-title-line-height, 1.2);
    font-weight: 600;

    margin-bottom: 0;

    display: -webkit-box;
    -webkit-line-clamp: 2;
    overflow: hidden;
    -webkit-box-orient: vertical;
    text-overflow: ellipsis;

    height: calc(2 * var(--card-post-title-size, 18px) * var(--card-post-title-line-height, 1.2));
}

.post-date {
    font-size: 80%;
    color: #888;
}

.post-synopsis {
    display: none;
}

.link-primary {
    display: flex;
    align-items: center;
    gap: 8px;

    font-size: 16px;

    .link-primary-icon {
        font-size: 16px;
    }
}

.home-news-footer {
    margin-top: 20px;
    display: flex;
    justify-content: center;
}

.tab-icon {
    padding-left: 15px;
    padding-right: 15px;
    justify-content: center;
    align-items: center;
    display: flex;
    height: 52px;

    border-left: 3px solid var(--primary);
    background-color: #fff;

    cursor: default;

    span {
        font-size: 32px;
        color: var(--primary);
    }
}

.tab-item {
    position: relative;

    &::before {
        content: '';
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        border-bottom: 1px solid var(--primary);
    }

}

@media screen and (min-width: 576px) {}

@media screen and (min-width: 768px) {
    .post-card {
        flex: 0 0 33.333333%;
        max-width: 33.333333%;
    }


}

@media (max-width: 991.98px) {
    .home-news-content {
        position: relative;
        display: flex;


        // margin-left: -15px;
        // gap: 8px;
        // margin-right: -15px;

        .home-news-tabs {
            margin: 0;
            flex: 0 0 25vw;
            max-width: 25vw;
            position: sticky;
            top: 0;

            .tabs {
                padding-right: 8px;
                flex-direction: column;
                // padding-bottom: 15px;
                // background-color: #f2f2f2;

                .tab-item {
                    display: flex;

                    &.tab-icon {
                        display: none;
                    }
                }

                .tab-link {
                    background-color: #f6f6f6;
                    width: 100%;
                    font-size: 14px;
                    padding: 8px 15px;
                    height: auto;

                    &.active {
                        background-color: var(--primary);
                    }
                }
            }
        }

        .home-news-post {
            flex: 1;
            overflow: hidden;


            .post-card {
                flex: 0 0 calc(calc(calc(100vw - 25vw) / 2) - 8px);
                max-width: calc(calc(calc(100vw - 25vw) / 2) - 8px);

                padding-right: 8px;
                margin-bottom: 8px;
            }
        }
    }
}

@media (max-width: 400px) {
    .home-news-content {
        .home-news-tabs {
            .tabs {
                .tab-link {
                    font-size: 14px;
                    padding-left: 8px;
                }
            }
        }

        .home-news-post {
            .post-card {
                flex: 0 0 calc(calc(100vw - 25vw) / 2);
                max-width: calc(calc(100vw - 25vw) / 2);
            }
        }

        .post-title {
            font-size: 14px;
            -webkit-line-clamp: 3;
            height: calc(3 * 14px * var(--card-post-title-line-height, 1.2));
        }
    }
}

@media screen and (min-width: 992px) {
    .home-news-content {
        margin: 0 auto;
        width: 100%;
        max-width: 1600px;
        padding-left: 15px;
        padding-right: 15px;
    }

    .home-news-tabs {
        margin-bottom: 30px;
    }

    .tabs {
        justify-content: center;
        align-items: center;
    }

    .subtitle {
        display: flex;
        gap: 6px;
        justify-content: center;
        align-items: center;

        margin-bottom: 15px;
    }

    .title {
        font-size: 48px;
    }

    .post-item {
        background-color: #fff;
        gap: 0;
    }

    .post-content {
        gap: 5px;
        padding: 15px;
    }

    .post-synopsis {
        color: #666;
        display: -webkit-box;
        -webkit-line-clamp: 5;
        overflow: hidden;
        -webkit-box-orient: vertical;
        text-overflow: ellipsis;

        font-size: var(--card-post-synopsis-size, 18px);
        line-height: var(--card-post-synopsis-line-height, 1.5);
        height: calc(5 * var(--card-post-synopsis-size, 18px) * var(--card-post-synopsis-line-height, 1.5));
    }

    .link-primary {
        display: inline-flex;

    }

    .link-primary-icon {
        opacity: 0;
        transform: translateX(-50%);
        transition: all .24s cubic-bezier(.22, 0, .08, 1)
    }
}

@media screen and (min-width: 1024px) {
    .post-card {
        flex: 0 0 25%;
        max-width: 25%;
    }

    .post-item {
        transition: box-shadow .24s cubic-bezier(.22, 0, .08, 1), transform .24s cubic-bezier(.22, 0, .08, 1);

        &:hover {
            transform: translateY(-4px);
            box-shadow: 0 4px 20px 0 rgba(0, 0, 0, .08);


            .link-primary-icon {
                opacity: 1;
                transform: translateX(0);
            }
        }
    }

    .home-news-footer {
        margin-top: 65px;
    }

    .post-title {
        font-size: 20px;
        height: calc(2 * 20px * var(--card-post-title-line-height, 1.2));
    }
}
</style>